export default __webpack_public_path__ + "static/media/gestao-projetos.7c42499f.svg";